import keyMirror from 'keymirror';

export const operatingSystems = keyMirror({
  android: null,
  ios: null,
  windowsPhone: null,
  unknown: null,
});

export const ANDROID_DOWNLOAD_LINK = 'https://play.google.com/store/apps/details?id=com.getfaf.cupcakeapp';
export const APPLE_DOWNLOAD_LINK = 'http://itunes.apple.com/app/id1455993160';

export function getMobileOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return operatingSystems.windowsPhone;
  }

  if (/android/i.test(userAgent)) {
    return operatingSystems.android;
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return operatingSystems.ios;
  }

  return operatingSystems.unknown;
}
